import { render, staticRenderFns } from "./edit-people.vue?vue&type=template&id=ecd4d350&scoped=true&"
import script from "./edit-people.vue?vue&type=script&lang=js&"
export * from "./edit-people.vue?vue&type=script&lang=js&"
import style0 from "./edit-people.vue?vue&type=style&index=0&id=ecd4d350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4d350",
  null
  
)

export default component.exports